<template>
  <div>
    <div v-for="opt in uiOptions" :key="opt.id" class="wd-flex wd-justify-between wd-my-4">
      <span class="wd-text-md">{{ opt.label }}</span>
      <AddSubNumberPicker :value="opt.value" @input="onNumberChange($event, opt.input_value)" />
    </div>
    <div v-if="errorMessage" class="wd-text-red50 wd-text-osm">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue'
import { syncRefs, watchDebounced } from '@vueuse/core'
import type { FormFieldOptionCreationData } from '@/view-models/remark'
import AddSubNumberPicker from '@/components/picker/add-sub-number-picker.vue'

export default defineComponent({
  components: {
    AddSubNumberPicker,
  },
  props: {
    options: { type: Array as PropType<{ id: number; label: string; value: number; input_value: FormFieldOptionCreationData }[]>, default: () => [] },
    modelValue: { type: Array as PropType<FormFieldOptionCreationData[]>, default: () => [] },
    errorMessage: { type: String },
  },
  emits: ['update:modelValue'],
  setup(props, ctx) {
    const numberValues = ref<FormFieldOptionCreationData[]>([])
    const { options, modelValue } = toRefs(props)
    const itemObject = ref<Record<string, string>>({})

    syncRefs(modelValue, numberValues)

    const uiOptions = computed(() => options.value?.map(opt => ({ ...opt, value: Number(itemObject.value[opt.id]) || 0 })))

    const itemArray = computed(() => Object.entries(itemObject.value).map(([key, value]) => ({ sub_id: Number(key), content: value })) || [])

    watch(
      numberValues,
      () => {
        itemObject.value = Object.fromEntries(numberValues.value.map(v => [v.sub_id, v.content]))
      },
      { deep: true, immediate: true }
    )

    function onNumberChange(value: number, optionData: FormFieldOptionCreationData) {
      itemObject.value = { ...itemObject.value, [optionData?.sub_id]: value.toString() }
      ctx.emit('update:modelValue', itemArray.value)
    }

    return {
      numberValues,
      uiOptions,
      itemObject,
      itemArray,
      onNumberChange,
    }
  },
})
</script>
